var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"d-flex justify-center mt-3"},[_c('v-card',{staticClass:"pa-0 ma-0",attrs:{"width":"593"}},[(_vm.linkInBio != null)?_c('Preview',{attrs:{"linkInBio":_vm.linkInBio,"isWebPage":true}}):_vm._e()],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }